module.exports = __webpack_public_path__ + "img/p004.8bdc9607.jpg";